import axios from "@/services/axios";
import UrlKeeper from '@/services/UrlKeeper.js'

class OtherCostsService {

  list(page, rowPerPage, filters) {
    const apiUrl = UrlKeeper.getUrl()

    return new Promise((resolve, reject) => {
      axios.post(apiUrl + '/payments/otherCosts/list', {
        page: page,
        rowPerPage: rowPerPage,
        filters: filters
      }).then((response) => {
        if (response.success) {
          resolve(response.results)
        } else {
          reject(response.results)
        }
      }).catch((err) => {

        reject(err)
      })
    })
  }

  create(otherCost) {
    const apiUrl = UrlKeeper.getUrl()

    return new Promise((resolve, reject) => {
      axios.post(apiUrl + '/payments/otherCosts/create', otherCost).then((response) => {
        if (response.success) {
          resolve(response.results)
        } else {
          reject(response.results)
        }
      }).catch((err) => {
        reject(err)
      })
    })
  }


  update(otherCost) {
    const apiUrl = UrlKeeper.getUrl()

    return new Promise((resolve, reject) => {
      axios.post(apiUrl + '/payments/otherCosts/update', { params: otherCost, id: otherCost.id }).then((response) => {
        if (response.success) {
          resolve(response.results)
        } else {
          reject(response.results)
        }
      }).catch((err) => {
        reject(err)
      })
    })
  }

  delete(otherCost) {
    const apiUrl = UrlKeeper.getUrl()

    return new Promise((resolve, reject) => {
      if (!otherCost.id) {
        reject('id undefined')
      }
      axios.post(apiUrl + '/payments/otherCosts/delete', {
        id: otherCost.id
      }).then((response) => {
        if (!response.success) {
          reject(response.results)
        } else {
          resolve(response.results)
        }
      }).catch((err) => {
        reject(err)
      })
    })
  }

  get(otherCostId) {
    const apiUrl = UrlKeeper.getUrl()

    return new Promise((resolve, reject) => {
      axios.get(apiUrl + '/payments/otherCosts/get', { id: otherCostId }).then((response) => {
        if (response.success) {
          resolve(response.results)
        } else {
          reject(response.results)
        }
      }).catch((err) => {
        reject(err)
      })
    })
  }

  fields() {
    return Promise.resolve([
      { text: 'Importo', value: 'amount', type: 'price' },
      { text: 'Descrizione', value: 'description' },
      { text: 'Codice', value: 'internalCode' },
      { text: 'Ragione Sociale', value: 'companyName', type: "custom" },
      { text: 'Numero Documento', value: 'documentNumber' },
      { text: 'Emesso il', value: 'emittedAt', type: "datetime" },
      { text: 'Data Scadenza', value: 'expirationDate', type: "datetime" },
    ])
  }

  _fieldsToExport() {
    return {
      'Importo': {
        callback: (row) => {
          return Number(row.amount).toFixed(2).replace('.', ',')
        }
      },
      'Descrizione': 'description',
      'Codice': 'internalCode',
      'Ragione Sociale': {
        callback: (row) => {
          if (!!row.supplier)
            return row.supplier.businessName
        }
      },
      'Numero Documento': 'documentNumber',
      'Emesso il': {
        callback: (row) => {
          if (!!row.emittedAt)
            return new Date(row.emittedAt).toLocaleDateString()
        }
      },
      'Data Scadenza': {
        callback: (row) => {
          if (!!row.expirationDate)
            return new Date(row.expirationDate).toLocaleDateString()
        }
      },
    }
  }
}

export default new OtherCostsService();
